import { Amplify } from 'aws-amplify';

export function configureAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: 'us-east-1_qX9K5CIL3',
        userPoolClientId: '209rf2gd8tb11or9eo329qmjhk',
      },
    },
  });
}
